import Button from '@hotmart/space-lib/dist/components/button';
import Icon from '@hotmart/space-lib/dist/components/icon';
import { faPenLine } from '@fortawesome/pro-light-svg-icons/faPenLine';
import { SurvicateUtils } from 'src/utils/survicate';
import i18n from 'src/i18n';
import { useUserProfile } from 'src/context/userProfileContext';
import { useTrackEvents } from 'src/context/userProfileContext/hooks';
import { useSessionData } from 'src/hook/useSessionData';
import { useGetUserData } from '../../hooks';
import { UserInfoSkeleton } from '../userInfoSkeleton';
import { UserInfoErrorState } from '../userInfoErrorState';
import { Avatar, AvatarWrapper, UserName, Wrapper } from './userInfo.styles';
import { AVATAR_DIMENSIONS, SURVICATE_ID } from './userInfo.constants';

const UserInfo = () => {
  const { user } = useSessionData();
  const { visible, userUcode = user?.ucode, loggedUserUcode } = useUserProfile();
  const { sendOpenMessageBoxEvent } = useTrackEvents({ loggedUserUcode });
  const { isLoading, isError, data } = useGetUserData({
    ucode: userUcode,
    avatarDimensions: AVATAR_DIMENSIONS,
    enabled: visible
  });

  const handleOpenSuvicate = () => {
    SurvicateUtils.showSurvey(SURVICATE_ID);
    sendOpenMessageBoxEvent({
      userUcode
    });
  };

  if (isLoading) {
    return (
      <Wrapper className="_border-bottom _border-gray-200">
        <UserInfoSkeleton />
      </Wrapper>
    );
  }

  if (isError) {
    return (
      <Wrapper className="_border-bottom _border-gray-200">
        <UserInfoErrorState />
      </Wrapper>
    );
  }

  return (
    <Wrapper className="_border-bottom _border-gray-200 _px-5 _pb-5">
      <div className="_d-flex _align-items-center">
        <AvatarWrapper className="_d-flex _align-items-center _flex-grow-0 _flex-shrink-0 _rounded-circle _overflow-hidden _mr-4">
          <Avatar src={data?.avatarUrl} alt="avatar" className="_w-full _h-full" />
        </AvatarWrapper>

        <UserName className="_text-gray-900 _font-weight-bold">{data?.name}</UserName>
      </div>

      <Button
        variation="secondary"
        className="_d-flex _align-items-center _justify-content-center _ _mb-2 _w-full _mt-5"
        onClick={handleOpenSuvicate}
      >
        <Icon icon={faPenLine} className="_text-gray-700 _mr-2" size="1x" />
        <span>{i18n.t('profile.user_info.button')}</span>
      </Button>
    </Wrapper>
  );
};

export default UserInfo;
